<template>
  <div class="rel">
    <!-- <v-btn class="absolute-close"  depressed dark  large  color="spiceRed"   @click="closeModal">
      <v-icon    >close</v-icon>
    </v-btn>-->
    <v-card flat class="transparent">
      <v-card-text class="inner-content mt-2">
        <v-layout row wrap>
          <v-flex md7 xs12>
            <h1 class="title pb-3">
              Payment
              <span>Services</span>
            </h1>
            <h3 class="pb-3">Spice Money Payment Solutions</h3>
            <p>Enable over 660 million+ Aadhaar linked bank account holders to transact card-less.</p>
            <p>Currently, only 3 million Point of Sale (POS) machines facilitate Debit/Credit Card payment to Merchants. Spice Money Aadhaar Pay Solution for small merchant will enable over 660 million+ Aadhaar linked bank account holders to transact card-less across merchant locations. Spice Money Agent will provide basic banking services such as balance inquiry, cash deposit/withdrawal and DMT to their customers and earn commission for every transaction.</p>
            <p>Spice Money Agent will enable the customer to have a hassles free transactions, customer need not carry his/her phone, debit card, credit card, remember PIN and with “Nil” MDR. This is an ideal situation for both the customer and agent. The customer can carry out any kind of banking transaction at their next door kirana store, without the hassle of actually travelling to far flung bank branches or standing in long queues.</p>
          </v-flex>
          <v-flex md5 xs12 class="text-xs-center pl-5" v-if="this.$vuetify.breakpoint.lgAndUp">
            <img :src="require('@/assets/images/payment.jpg')" alt="spice money" width="100%">
          </v-flex>
          <v-flex xs12 pt-3>
            <ul class="icon-triggers">
              <li :class="aadhaarpay?'active':''" @click="qr=false;upi=false; aadhaarpay=true">
                <!-- <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M17.81,4.47C17.73,4.47 17.65,4.45 17.58,4.41C15.66,3.42 14,3 12,3C10.03,3 8.15,3.47 6.44,4.41C6.2,4.54 5.9,4.45 5.76,4.21C5.63,3.97 5.72,3.66 5.96,3.53C7.82,2.5 9.86,2 12,2C14.14,2 16,2.47 18.04,3.5C18.29,3.65 18.38,3.95 18.25,4.19C18.16,4.37 18,4.47 17.81,4.47M3.5,9.72C3.4,9.72 3.3,9.69 3.21,9.63C3,9.47 2.93,9.16 3.09,8.93C4.08,7.53 5.34,6.43 6.84,5.66C10,4.04 14,4.03 17.15,5.65C18.65,6.42 19.91,7.5 20.9,8.9C21.06,9.12 21,9.44 20.78,9.6C20.55,9.76 20.24,9.71 20.08,9.5C19.18,8.22 18.04,7.23 16.69,6.54C13.82,5.07 10.15,5.07 7.29,6.55C5.93,7.25 4.79,8.25 3.89,9.5C3.81,9.65 3.66,9.72 3.5,9.72M9.75,21.79C9.62,21.79 9.5,21.74 9.4,21.64C8.53,20.77 8.06,20.21 7.39,19C6.7,17.77 6.34,16.27 6.34,14.66C6.34,11.69 8.88,9.27 12,9.27C15.12,9.27 17.66,11.69 17.66,14.66A0.5,0.5 0 0,1 17.16,15.16A0.5,0.5 0 0,1 16.66,14.66C16.66,12.24 14.57,10.27 12,10.27C9.43,10.27 7.34,12.24 7.34,14.66C7.34,16.1 7.66,17.43 8.27,18.5C8.91,19.66 9.35,20.15 10.12,20.93C10.31,21.13 10.31,21.44 10.12,21.64C10,21.74 9.88,21.79 9.75,21.79M16.92,19.94C15.73,19.94 14.68,19.64 13.82,19.05C12.33,18.04 11.44,16.4 11.44,14.66A0.5,0.5 0 0,1 11.94,14.16A0.5,0.5 0 0,1 12.44,14.66C12.44,16.07 13.16,17.4 14.38,18.22C15.09,18.7 15.92,18.93 16.92,18.93C17.16,18.93 17.56,18.9 17.96,18.83C18.23,18.78 18.5,18.96 18.54,19.24C18.59,19.5 18.41,19.77 18.13,19.82C17.56,19.93 17.06,19.94 16.92,19.94M14.91,22C14.87,22 14.82,22 14.78,22C13.19,21.54 12.15,20.95 11.06,19.88C9.66,18.5 8.89,16.64 8.89,14.66C8.89,13.04 10.27,11.72 11.97,11.72C13.67,11.72 15.05,13.04 15.05,14.66C15.05,15.73 16,16.6 17.13,16.6C18.28,16.6 19.21,15.73 19.21,14.66C19.21,10.89 15.96,7.83 11.96,7.83C9.12,7.83 6.5,9.41 5.35,11.86C4.96,12.67 4.76,13.62 4.76,14.66C4.76,15.44 4.83,16.67 5.43,18.27C5.53,18.53 5.4,18.82 5.14,18.91C4.88,19 4.59,18.87 4.5,18.62C4,17.31 3.77,16 3.77,14.66C3.77,13.46 4,12.37 4.45,11.42C5.78,8.63 8.73,6.82 11.96,6.82C16.5,6.82 20.21,10.33 20.21,14.65C20.21,16.27 18.83,17.59 17.13,17.59C15.43,17.59 14.05,16.27 14.05,14.65C14.05,13.58 13.12,12.71 11.97,12.71C10.82,12.71 9.89,13.58 9.89,14.65C9.89,16.36 10.55,17.96 11.76,19.16C12.71,20.1 13.62,20.62 15.03,21C15.3,21.08 15.45,21.36 15.38,21.62C15.33,21.85 15.12,22 14.91,22Z"
                  ></path>
                </svg>-->
                Aadhaar Pay
              </li>
              <li :class="upi?'active':''" @click="qr=false;upi=true; aadhaarpay=false">
                <!-- <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="100%"
                  height="100%"
                  viewBox="0 0 412.996 412.996"
                  style="enable-background:new 0 0 412.996 412.996;"
                  xml:space="preserve"
                >
                  <path
                    d="M392.996,28.338H20c-11.047,0-20,8.954-20,20v234c0,11.046,8.953,20,20,20h139.498v45.32h-54.283     c-10.201,0-18.5,8.299-18.5,18.5s8.299,18.5,18.5,18.5h202.566c10.201,0,18.5-8.299,18.5-18.5s-8.299-18.5-18.5-18.5h-54.283     v-45.32h139.498c11.047,0,20-8.954,20-20v-234C412.996,37.292,404.043,28.338,392.996,28.338z M382.996,272.338H30v-214h352.996     V272.338z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M94.591,176.637l63.084,29.336c1.631,0.755,3.367,1.138,5.162,1.138c2.338,0,4.616-0.664,6.597-1.924     c3.548-2.267,5.666-6.13,5.666-10.335v-0.322c0-4.751-2.785-9.115-7.096-11.119l-39.455-18.33l39.456-18.334     c4.31-2.004,7.095-6.369,7.095-11.118v-0.319c0-4.211-2.119-8.074-5.665-10.334c-1.962-1.254-4.247-1.916-6.606-1.916     c-1.778,0-3.563,0.391-5.16,1.133L94.59,153.525c-4.308,2.005-7.091,6.369-7.091,11.117v0.878     C87.498,170.262,90.28,174.625,94.591,176.637z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M175.662,236.389c2.301,3.149,6.002,5.029,9.901,5.029h0.315c5.352,0,10.042-3.426,11.672-8.516l41.557-128.76     c1.192-3.717,0.53-7.818-1.771-10.974c-2.301-3.149-6.002-5.03-9.901-5.03h-0.314c-5.354,0-10.048,3.426-11.679,8.516     L173.88,225.425C172.698,229.145,173.364,233.242,175.662,236.389z"
                    fill="#FFFFFF"
                  ></path>
                  <path
                    d="M237.896,135.628c0,4.746,2.782,9.11,7.095,11.122l39.455,18.33l-39.455,18.33c-4.311,2.004-7.096,6.368-7.096,11.119     v0.322c0,4.205,2.117,8.068,5.669,10.336c1.974,1.258,4.254,1.923,6.595,1.923c1.792,0,3.527-0.383,5.169-1.142l63.081-29.335     c4.307-2.009,7.089-6.372,7.089-11.115v-0.878c0-4.748-2.783-9.112-7.093-11.117l-63.08-29.334     c-1.591-0.739-3.373-1.131-5.152-1.131c-2.358,0-4.644,0.662-6.604,1.912c-3.554,2.264-5.673,6.127-5.673,10.338V135.628     L237.896,135.628z"
                    fill="#FFFFFF"
                  ></path>
                </svg>-->
                UPI
              </li>
              <li :class="qr?'active':''" @click="qr=true;upi=false; aadhaarpay=false">
                <!-- <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M7,2H17A2,2 0 0,1 19,4V20A2,2 0 0,1 17,22H7A2,2 0 0,1 5,20V4A2,2 0 0,1 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z"
                  ></path>
                </svg>-->
                mPOS
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-4 v-if="aadhaarpay">
            <v-flex xs12>
              <h2>Aadhaar Pay</h2>
              <h3 class="pb-3">Spice Money Aadhaar Pay Service</h3>
            </v-flex>
            <v-flex md12 xs12>
              <p>Spice Money Aadhaar Pay is a digital payment solution that enables agent to accept payments for goods/services using their android Smartphone and Biometric scanner from customers having Aadhaar seeded bank account.
                <br>We are offering "Nil" MDR below Rs 2000 transaction value.
              </p>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-4 v-if="upi">
            <v-flex xs12>
              <h2>BHIM - UPI</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>
                <strong>Accept payments from Scan & Pay BHIM UPI app</strong>
              </p>
              <p>
                <em>Key Features</em>
              </p>
              <ul class="standard-listing two">
                <li>
                  <strong>Banking fees:</strong>₹ 1 – ₹ 1,999: (Nil)
                </li>
                <li>
                  <strong>Banking fees:</strong>₹ 2,000 - ₹ 1 lakh : (₹ 10)
                </li>
                <li>
                  <strong>Advantage</strong> Scan to Pay Safer. Pay through all major UPI app
                </li>
                <li>
                  <strong>Cashback</strong> Customer earns upto ₹ 750 per month using BHIM UPI app
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-4 v-if="qr">
            <v-flex xs12>
              <h2>Rent free mPOS</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>
                <strong>
                  Accept payments using
                  <strong>Debit</strong> and
                  <strong>Credit Card</strong>
                </strong>
              </p>
              <p>
                <em>Key Features</em>
              </p>
              <ul class="standard-listing two">
                <li>Earn Cash@POS at ₹4 per transaction</li>
                <li>“Nil” MDR on transactions upto ₹ 2000/-</li>
                <li>Standard “MDR”on Debit and Credit card swipe</li>
                <li>
                  <strong>Hardware requirement</strong> mPoS provided by Spice Money
                </li>
              </ul>
            </v-flex>
          </v-layout>
        </transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #333;
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 10px;
}
.nav-listing li a {
  text-decoration: none;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}

.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 12px 0 0px 50px;
  background: #293896;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  min-width: 100px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  opacity: 0.7;
  border-bottom: solid 3px tranparent;
  margin-right: 5px;
}
.icon-triggers li.active,
.icon-triggers li:hover {
  opacity: 1;
  border-bottom: solid 3px orange;
}
/* .icon-triggers {
  list-style: none;
  margin: 0;
  padding: 30px 0 0 0;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: #ff7a00;
  border: 3px solid #ff7a00;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  line-height: 0;
  padding: 1.9em;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 120px;
  height: 120px;
  margin-right: 10%;
  animation: categoryTriggerPulse 3s infinite;
}

.icon-triggers li:before,
.icon-triggers li:after {
  content: "";
  display: block;
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.icon-triggers li:before {
  border: 2px solid #ff7a00;
}

.icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
}

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
} */

.standard-listing {
  color: #343434;
}
.standard-listing.two li {
  width: 100%;
}
.standard-listing li {
  float: left;
  width: 50%;
}
@media only screen and (max-width: 768px) {
  .title {
    font-size: 18px !important;
  }
}
.earn-now {
  position: relative;
  padding: 25px 30px;
  background: #2d2d2d;
  font-size: 30px;
  color: #fff;
  font-family: "Poppins", sans-serif;
  font-weight: bold;
}
.join-now {
  background: #ec1c25;
  padding: 0px 45px;
  height: 83px;
  line-height: 83px;
  text-transform: uppercase;
  color: #fff;
  display: inline-block;
  font-size: 30px;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  text-decoration: none;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.52);
  z-index: 2;
  transition: all ease-in-out 0.3s;
}

.join-now:hover {
  border-radius: 5px;
  -webkit-box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
  box-shadow: 5px 5px 6px 0px rgba(0, 0, 0, 0.67);
}

@media only screen and (max-width: 768px) {
  .earn-now {
    position: relative;
    padding: 15px 20px;
    font-size: 22px;
  }
  .join-now {
    padding: 0px 25px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    margin-top: 15px;
  }
  .icon-triggers li {
    width: 40px;
    height: 40px;
    padding: 5px;
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 14px;
  }
}
@media only screen and (max-width: 550px) {
  .icon-triggers {
    padding: 0;
  }
  .icon-triggers li {
    width: 100%;
    margin: 0;
    padding: 0;
    line-height: 40px;
  }
}
</style>

<script>
import PaymentDetails from "./PaymentDetails.ts";
export default PaymentDetails;
</script>